import { h, Component } from "preact";
import { connect } from "preact-redux";
import style from "./style.scss";
import Input from "/chat/src/components/Forms/Input";
import SelectInput from "/chat/src/components/Forms/SelectInput";
import Textarea from "/chat/src/components/Forms/Textarea";
//import ConversationClass from '/chat/src/lib/Conversation';
import SystemModel from "/chat/src/redux/model/system/model";
import CustomizationModel from "/chat/src/redux/model/customization/model";
import { TicketModel, FeaturesModel } from "/chat/src/redux/model";
import UserModel from "/chat/src/redux/model/user/model";
import HistoryIcon from "/chat/src/components/SVGImages/History";
import Validation from "/chat/src/lib/Validation";

import PoweredByJibber from "/chat/src/components/PoweredByJibber";

class StartChattingButton extends Component {
  constructor(props) {
    super(props);
    let offlineFormsConfig = props.offlineSettings.config;
    this.state = {
      send: false,
      select: [],
      selectValidate: true,
      forms: {
        email: {
          value: props.user.email,
          require: offlineFormsConfig.email.require,
          visible: offlineFormsConfig.email.visible,
          alias: offlineFormsConfig.email.alias,
          missing: false,
          isValidate: true,
          validate: Validation.validateEmail,
        },
        name: {
          value: props.user.name,
          require: offlineFormsConfig.name.require,
          visible: offlineFormsConfig.name.visible,
          alias: offlineFormsConfig.name.alias,
          missing: false,
          isValidate: true,
          validate: Validation.validateDummy,
        },
        phone: {
          value: props.user.phone,
          require: offlineFormsConfig.phone.require,
          visible: offlineFormsConfig.phone.visible,
          alias: offlineFormsConfig.phone.alias,
          missing: false,
          isValidate: true,
          validate: Validation.validateDummy,
        },
        customerRef: {
          value: props.user.customer_ref,
          require: offlineFormsConfig.customer_ref.require,
          visible: offlineFormsConfig.customer_ref.visible,
          alias: offlineFormsConfig.customer_ref.alias,
          missing: false,
          isValidate: true,
          validate: Validation.validateDummy,
        },
        message: {
          require: true,
          visible: true,
          value: "",
          missing: false,
          isValidate: true,
          validate: Validation.validateDummy,
        },
      },
      historyIconHover: false,
    };
    this.handleNewConversationClick = this.handleNewConversationClick.bind(
      this
    );
    this.renderForm = this.renderForm.bind(this);
  }

  handleNewConversationClick() {
    let missing = false;
    let newState = { ...this.state };
    const { exchangeAvailable, exchangePayload, offlineSettings } = this.props;
    const { forms, select } = this.state;

    let isValidate = true;
    let formsConfig = offlineSettings.config;
    for (var form in forms) {
      let value = forms[form].value;
      if (!value && forms[form].require && forms[form].visible) {
        newState.forms[form].missing = true;
        missing = true;
      } else {
        newState.forms[form].missing = false;
      }
      if (value && !newState.forms[form].validate(value)) {
        newState.forms[form].isValidate = false;
        isValidate = false;
      }
    }
    if (exchangeAvailable && exchangePayload.exchange_on) {
      if (select.length == 0) {
        newState.selectValidate = false;
      }
    }

    if (!isValidate || missing) {
      this.setState(newState);
      return;
    }

    let payload = {
      email: forms.email.value,
      name: forms.name.value,
      phone: forms.phone.value,
      customer_ref: forms.customerRef.value,
    };
    let last;
    if (select.length > 0) {
      const options = exchangePayload.options;
      last = _.last(select);
    }
    this.props.dispatch(
      TicketModel.requestNewOfflineTicket(forms.message.value, payload, last)
    );
    this.setState({ send: true });
  }
  renderForm(form, label) {
    const obj = this.state.forms[form];
    const require = obj.require;
    const visible = obj.visible;
    if (visible) {
      const value = obj.value;
      const missing = obj.missing;
      const isValidate = obj.isValidate;
      return (
        <div
          style={{ position: "relative", width: "70%", margin: "12px auto" }}
        >
          <Input
            label={label}
            value={value}
            onChange={(newValue) => {
              const newState = { ...this.state };
              newState.forms[form].value = newValue;
              this.setState(newState);
            }}
            require={require}
            missing={missing}
            isValidate={isValidate}
          />
        </div>
      );
    }
    return null;
  }
  renderExchange() {
    if (!this.props.exchangeAvailable) return null;
    if (!this.props.exchangePayload.exchange_on) return null;
    let language = this.props.language;

    const options = _.filter(this.props.exchangePayload.options, [
      "visible",
      true,
    ]);

    var values = { "-1": language.get("Others") };
    for (var index in options) {
      values[options[index].id] = options[index].label;
    }
    var option = _.find(options, (o) => {
      return o.id === this.state.select[0];
    });

    var ChildInput = null;
    var hasChildren = option ? _.size(option.children) > 0 : false;
    if (hasChildren) {
      var childrenValues = { [option.id]: language.get("Others") };
      for (var index in option.children) {
        childrenValues[option.children[index].id] =
          option.children[index].label;
      }
      ChildInput = (
        <SelectInput
          values={childrenValues}
          onChange={(e) => {
            var list = [...this.state.select];
            list[1] = e.target.value;
            this.setState({ select: list });
          }}
          select={this.state.select[1]}
          label={language.get("SelectTopic")}
          isValidate={this.state.selectValidate}
        />
      );
    }

    //<div style={{fontSize: '14px', color: '#404040', margin: '5px 0px'}}>
    //    Vad gäller ditt ärende
    //</div>
    return (
      <div style={{ position: "relative", width: "70%", margin: "15px auto" }}>
        <div style={{ fontSize: "14px", color: "#404040", margin: "5px 0px" }}>
          {language.get("SelectTopicHeader")}
        </div>
        <SelectInput
          values={values}
          onChange={(e) => {
            this.setState({ select: [e.target.value] });
          }}
          select={this.state.select[0]}
          label={language.get("SelectTopic")}
          isValidate={this.state.selectValidate}
        />
        {hasChildren && ChildInput}
      </div>
    );
  }

  renderOfflineForms() {
    //Minus (Powered by Jibber) height
    const bodyHeight = this.props.height - 35;
    const language = this.props.language;

    let formsCount = 0;
    for (var form in this.props.offlineSettings.config) {
      if (this.props.offlineSettings.config[form].visible) {
        formsCount += 1;
      }
    }
    const paddingTop = "50" - formsCount * 10 + "px";

    const PreviousConversationsButtonProps = {
      title: language.get("ViewPreviousConversation"),
      onClick: () => this.props.dispatch(SystemModel.setRoute("Conversations")),
      onMouseOver: () => this.setState({ historyIconHover: true }),
      onMouseLeave: () => this.setState({ historyIconHover: false }),
      style: {
        minHeight: "1px",
        float: "left",
        display: "inline-block",
        width: "48px",
        cursor: "pointer",
      },
    };
    const TextareaProps = {
      label: language.get("Message"),
      value: this.state.forms.message.value,
      onChange: (newValue) => {
        const newState = { ...this.state };
        newState.forms.message.value = newValue;
        this.setState(newState);
      },
      missing: this.state.forms.message.missing,
      require: true,
    };

    const customerRef = this.state.forms.customerRef;
    var customerRefLabel;
    switch (customerRef.alias) {
      case "ord":
        customerRefLabel = language.get("OrderNo.");
        break;
      case "cust":
        customerRefLabel = language.get("CustomerNo.");
        break;
      case "ref":
      default:
        customerRefLabel = language.get("ReferenceNo.");
        break;
    }

    return (
      <div
        className={style.StartChattingButtonWrapper}
        style={{ paddingTop: paddingTop, minHeight: `${bodyHeight}px` }}
      >
        <form>
          {this.renderForm(
            "email",
            language.get("Email"),
            Validation.validateEmail
          )}
          {this.renderForm("name", language.get("Name"))}
          {this.renderForm("phone", language.get("Phone"))}
          {this.renderForm("customerRef", customerRefLabel)}
          <div
            style={{
              position: "relative",
              width: "70%",
              margin: "auto",
              marginBottom: "10px",
            }}
          >
            <Textarea {...TextareaProps} />
          </div>
        </form>
        {this.renderExchange()}
        <div style={{ width: "100%", marginLeft: "20%" }}>
          <div
            className={style.StartChattingButton}
            onClick={this.handleNewConversationClick}
          >
            <div {...PreviousConversationsButtonProps}>
              {this.props.conversations.size !== 0 && ( // above is for placeholder, if no img found
                <HistoryIcon
                  color={
                    this.state.historyIconHover ? this.props.color : "#898989"
                  }
                />
              )}
            </div>
            <div
              style={{
                backgroundColor: this.props.color,
                color: "white",
                height: "55px",
                lineHeight: "55px",
                borderRadius: "60px",
                float: "left",
                paddingLeft: "4px",
                paddingRight: "4px",
              }}
            >
              <span className={style.StartChattingText}>
                {" "}
                {language.get("LeaveMessage")}{" "}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
  renderSend() {
    const bodyHeight = this.props.height;
    const language = this.props.language;

    let marginTop = bodyHeight / 2 - 50;
    let marginBottom = bodyHeight / 2 - 120;

    return (
      <div
        style={{
          marginTop: marginTop,
          marginBottom: marginBottom,
        }}
        className={style.StartChattingButtonWrapper}
      >
        <div
          style={{
            padding: "0 20px 20px 20px",
            fontSize: "20px",
            marginLeft: "auto",
            marginRight: "auto",
            whiteSpace: "pre-wrap",
          }}
        >
          {language.get("OfflineThanksMessage")}
        </div>
        <div style={{ marginLeft: "20%", width: "100%", height: "65px" }}>
          {this.props.conversations.size !== 0 ? (
            <img
              title={language.get("ViewPreviousConversation")}
              style={{
                height: "40px",
                float: "left",
                marginRight: "5px",
                cursor: "pointer",
                marginTop: "5px",
              }}
              onClick={() => {
                this.props.dispatch(SystemModel.setRoute("Conversations"));
              }}
              src="common/assets/images/Menu_History.png"
            />
          ) : (
            <div style={{ width: "20px", height: "1px", float: "left" }} />
          )}
          <div
            className={style.StartChattingButton + " hvr-grow"}
            onClick={(event) => {
              this.setState({ send: false });
            }}
            style={{
              backgroundColor: this.props.color,
              color: "white",
              width: "50%",
              borderRadius: "60px",
              float: "left",
              height: "55px",
              lineHeight: "55px",
            }}
          >
            <span className={style.StartChattingText}>
              {" "}
              {language.get("LeaveMessage")}{" "}
            </span>
          </div>
        </div>
      </div>
    );
  }
  render() {
    if (this.state.send) {
      return this.renderSend();
    }
    return this.renderOfflineForms();
  }
}

function mapStateToProps(state) {
  return {
    height: SystemModel.getBodyHeight(state),
    width: SystemModel.getShellWidth(state),
    language: CustomizationModel.getLanguage(state),
    color: CustomizationModel.getColor(state),
    conversations: TicketModel.getAll(state),
    offlineSettings: CustomizationModel.getOfflineFormsSettings(state).toJS(),
    user: UserModel.get(state).toJS(),
    exchangeAvailable: FeaturesModel.getFeatureAvailable(state, "exchange"),
    exchangePayload: FeaturesModel.getFeaturePayload(state, "exchange"),
  };
}

export default connect(mapStateToProps)(StartChattingButton);



// WEBPACK FOOTER //
// ./routes/OfflineFormular/Button.js